"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// (C) 2019-2022 GoodData Corporation
// eslint-disable-next-line import/no-unassigned-import
require("@formatjs/intl-pluralrules");
// eslint-disable-next-line import/no-unassigned-import
require("@formatjs/intl-pluralrules/polyfill-locales");
//# sourceMappingURL=polyfills.js.map